import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    marginBottom: 10,
  },
  scale_name: {
    fontSize: 18,
    fontWeight: 400,
  },
}));
